import './SEOFreeBanner.css'

interface Props { onStart: () => void }

export function SEOFreeBanner({ onStart }: Props) {
  return (
    <div className="seo-free-banner">
      <span className="seo-free-gift">🎁</span>
      <div className="seo-free-text">
        <strong>Jetzt kostenlos PDF herunterladen</strong>
        <span>Echtes PDF · 50 Nachrichten · Mit Wasserzeichen · Kein Account nötig</span>
      </div>
      <button className="seo-btn-primary" onClick={onStart}>Gratis starten</button>
    </div>
  )
}
